import React from "react";
import { Navigate } from "react-router-dom";

const RequireAuth = ({ children }) => {
  const token = localStorage.getItem("spinlab_token");
  if (!token) return <Navigate to="/admin" replace />;
  return children;
};

export default RequireAuth;
